app.controller("DefineInTableController", ["$scope", "Session", "Selection", "Subject", "TimetableService", "StaticData", "$stateParams", "$uibModalInstance", "params", "toastr",
    function ($scope, Session, Selection ,Subject, TimetableService, StaticData, $stateParams, $uibModalInstance, params, toastr) {
        $scope.subject = null;
        $scope.day = params.day;
        $scope.room = params.room;
        $scope.startTime = new Date(0, 0, 0, params.startTime, 0);

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        $scope.$watch('subject', function (val) {
            if (val && val._id) {
                Session.groupListBySubjectId(val.subject._id).then(function (data) {
                    $scope.groups = data;
                })
            }
        }, true);

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }

            var now = new Date();
            var season = now.getMonth() < 7 ? 'spring' : 'autumn';
            var year = now.getFullYear();

            // var season = 'autumn';
            // var year = 2017;

            var date = new Date(parseInt(year), season === 'spring' ? 2 : 10, 15);

            return  Selection.list({date: date, query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.saveSessions = function () {
            if(!$scope.subject) toastr.error('', 'გთხოვთ მიუთითოთ საგანი.');
            else if(!$scope.group) toastr.error('', 'გთხოვთ აირჩიოთ სესსის ჯგუფი.');
            else {
                $scope.group = JSON.parse($scope.group);
                if ($scope.group) {
                    var sessions = [];
                    for (var i = 0; i < $scope.group.duration; i++) {
                        sessions.push({
                            room: $scope.room._id,
                            dayOfWeek: $scope.day,
                            startTime: new Date(0, 0, 0, params.startTime + i, 0)
                        })
                    }
                    TimetableService.insertGroup({
                        sessions: sessions,
                        group: $scope.group._id
                    }).then(function () {
                        toastr.success('', 'სესიის ჯგუფი წარმატებით განისაზღვრა ცხრილში');
                        $uibModalInstance.close();
                    }).catch(function (err) {
                        if (err.status == 400) {
                            toastr.error('', 'ლექტორი ან ოთახი ამ დროს დაკავებულია.');
                        }
                    });
                }
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);